<template>
  <a-dropdown :trigger="['click']" placement="bottom">
    <a-button class="secondary_medium" @click="handleButtonClick">
      <ThemeImage :icon="imageNames.PLUS" alt="add_icon" class="size-4" />
      {{ buttonText }}
    </a-button>
    <template #overlay>
      <a-menu class="dropdown_menu">
        <a-menu-item
          v-for="item in menuItems"
          :key="item.type"
          @click="handleSelect(item)"
        >
          <div v-if="showDescription" class="flex items-start gap-2 px-3">
            <ThemeImage
              :icon="item.icon"
              :alt="`${item.type}_icon`"
              class="size-5 flex-shrink-0 mt-1"
            />
            <div class="flex flex-col gap-1 justify-center">
              <span class="font-semibold">{{ item.label }}</span>
              <span class="text-xs secondary_color">{{
                item.description
              }}</span>
            </div>
          </div>

          <div v-else class="flex items-center gap-2">
            <ThemeImage
              :icon="item.icon"
              :alt="`${item.type}_icon`"
              class="size-4"
            />
            <span>{{ item.label }}</span>
          </div>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script setup>
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

defineProps({
  buttonText: {
    type: String,
    default: "Add",
  },
  menuItems: {
    type: Array,
    required: true,
  },
  showDescription: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["select", "buttonClick"]);

const handleButtonClick = (e) => {
  emit("buttonClick", e);
};

const handleSelect = (item) => {
  emit("select", item);
};
</script>

